import apiClient from "services/axios";
import store from "store";

const API = {
  list: "/api/v1/users",
  create: "/api/v1/users",
  detail: "/api/v1/users",
  update: "/api/v1/users",
  delete: "/api/v1/users",
};

export const list = async (filter) => {
  const response = await apiClient.get(API.list, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const create = async (body) => {
  const response = await apiClient.post(API.create, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const detail = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const update = async (id, body) => {
  const response = await apiClient.patch(`${API.update}/${id}`, body);
  if (response) {
    const { name, id } = response.data;
    const user = store.get("user");
    if (user && user.id === id) {
      const newUser = { ...user, name: name };
      store.set("user", newUser);
    }
    return response.data;
  }
  return false;
};

export const remove = async (id) => {
  const response = await apiClient.delete(`${API.delete}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};
